import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const authzPermissionGroupMenuRegistry = {
    core_authzPermissionGroup: {
        label: "Authz Permission Group",
        link: PAGE_URL.AUTHZ_PERMISSION_GROUP_PAGE,
        key: PAGE_URL.AUTHZ_PERMISSION_GROUP_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default authzPermissionGroupMenuRegistry;
